import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Register() {
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect') || '/dashboard';
  const prefillEmail = searchParams.get('email') || '';

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: prefillEmail,
    password: '',
    password_confirm: '',
  });
  const [consentTerms, setConsentTerms] = useState(false);
  const [consentPrivacy, setConsentPrivacy] = useState(false);
  const [consentNewsletter, setConsentNewsletter] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.password !== form.password_confirm) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const { password_confirm, ...submitData } = form;
      await register({
        ...submitData,
        consent_terms: consentTerms,
        consent_privacy: consentPrivacy,
        consent_newsletter: consentNewsletter,
      });
      navigate(redirectTo, { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Registrierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = consentTerms && consentPrivacy;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1>CoachDesk365</h1>
          <p className="text-muted">Erstellen Sie Ihr Konto</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Vorname</label>
              <input
                name="first_name"
                value={form.first_name}
                onChange={handleChange}
                placeholder="Vorname"
                required
              />
            </div>
            <div className="form-group">
              <label>Nachname</label>
              <input
                name="last_name"
                value={form.last_name}
                onChange={handleChange}
                placeholder="Nachname"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>E-Mail</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="ihre@email.de"
              required
            />
          </div>
          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Mindestens 8 Zeichen"
              minLength={8}
              required
            />
          </div>
          <div className="form-group">
            <label>Passwort bestätigen</label>
            <input
              type="password"
              name="password_confirm"
              value={form.password_confirm}
              onChange={handleChange}
              placeholder="Passwort wiederholen"
              minLength={8}
              required
            />
          </div>

          <div className="consent-checkboxes" style={{ marginBottom: 16 }}>
            <label className="consent-checkbox-item">
              <input
                type="checkbox"
                checked={consentTerms}
                onChange={(e) => setConsentTerms(e.target.checked)}
              />
              <span>
                Ich akzeptiere die{' '}
                <a href="/agb" target="_blank" rel="noopener noreferrer">
                  AGB
                </a>{' '}
                *
              </span>
            </label>
            <label className="consent-checkbox-item">
              <input
                type="checkbox"
                checked={consentPrivacy}
                onChange={(e) => setConsentPrivacy(e.target.checked)}
              />
              <span>
                Ich habe die{' '}
                <a href="/datenschutz" target="_blank" rel="noopener noreferrer">
                  Datenschutzerkl&auml;rung
                </a>{' '}
                gelesen und akzeptiere sie *
              </span>
            </label>
            <label className="consent-checkbox-item">
              <input
                type="checkbox"
                checked={consentNewsletter}
                onChange={(e) => setConsentNewsletter(e.target.checked)}
              />
              <span>Newsletter und Updates erhalten (optional)</span>
            </label>
          </div>

          <button
            type="submit"
            className="btn btn-primary auth-submit"
            disabled={loading || !canSubmit}
          >
            {loading ? 'Wird erstellt...' : 'Konto erstellen'}
          </button>
        </form>

        <p className="auth-footer">
          Bereits registriert? <Link to={redirectTo !== '/dashboard' ? `/login?redirect=${encodeURIComponent(redirectTo)}` : '/login'}>Anmelden</Link>
        </p>
      </div>
    </div>
  );
}
